import Viewport from "../../Viewport/Viewport";
import React from "react";
import { Position } from "puzzle";

export class SupplierViewport extends Viewport {

  static defaultProps = {
    moduleName: 'Viewport'
  };

  /**
   * @inheritDoc
   */
  navLinkOnClick = (event: React.MouseEvent, path: string) => {
    const pathname = document.location.pathname;
    //clears persistent filter from dispatcher
    this.dispatch('clearFilterMainGrid');
    if (pathname.includes('/view/preferences')) {
      this.dispatch('checkForPreferencesBeforeRedirect', {
        pos: Position.start,
        persistent: ['path']
      }, { path });
    } else {
      this.dispatch('reloadPathPD', '', { path })
    }
  };

}